import RankAdmin from '../img/icons/rank-admin.png';
import RankBanned from '../img/icons/rank-banned.png';
import RankCalendarPlanner from '../img/icons/rank-betatester.png';
import RankNationCommittee from '../img/icons/rank-nationcommittee.png';
import RankFairplay from '../img/icons/rank-fairplay.png';

const rankMappings = [
    { rank: 'Admin', picture: RankAdmin, acronym: 'A' },
    { rank: 'Banned', picture: RankBanned, acronym: 'BAN' },
    { rank: 'CalendarPlanner', picture: RankCalendarPlanner, acronym: 'CP' },
    { rank: 'NationsCommittee', picture: RankNationCommittee, acronym: 'NC' },
    { rank: 'FairplayCommittee', picture: RankFairplay, acronym: 'FPC' }
];

export function getRankAcronym(rank) {
    let rankMapping = rankMappings.find(rankMapping => rankMapping.rank === rank);
    if (typeof rankMapping !== 'undefined') return rankMapping.acronym;
    else return null;
};

export function getRankSymbol(rank) {
    let rankMapping = rankMappings.find(rankMapping => rankMapping.rank === rank);
    if (typeof rankMapping !== 'undefined') return rankMapping.picture;
    else return null;
};
